var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.activeLayer
    ? _c(
        "v-flex",
        { staticStyle: { padding: "0 20px" }, attrs: { xs6: "" } },
        [
          _c(
            "v-tabs",
            {
              key: _vm.layersAsString,
              attrs: {
                "background-color": "transparent",
                "show-arrows": "",
                height: "20px",
                "slider-color": "primary"
              },
              model: {
                value: _vm.activeLayer,
                callback: function($$v) {
                  _vm.activeLayer = $$v
                },
                expression: "activeLayer"
              }
            },
            _vm._l(_vm.layersToShow, function(tab) {
              return _c(
                "v-tab",
                {
                  key: tab,
                  staticStyle: { "font-size": "10px" },
                  attrs: { href: "#" + tab }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$tc(_vm.getLayerTranslationKey(tab), 2)) +
                      "\n    "
                  )
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "home-form-table-toolbar",
            { staticClass: "mt-2" },
            [
              _c("home-form-table-refresh-tool", {
                attrs: { disabled: !_vm.toolbarEnabled },
                on: { click: _vm.refreshTableData }
              }),
              _vm._v(" "),
              _c("home-form-table-select-all-tool", {
                attrs: { disabled: !_vm.toolbarEnabled },
                on: { click: _vm.selectAllTableRows }
              }),
              _vm._v(" "),
              _c("home-form-table-select-invert-tool", {
                attrs: { disabled: !_vm.toolbarEnabled },
                on: { click: _vm.invertTableRowsSelection }
              }),
              _vm._v(" "),
              _c("home-form-table-select-none-tool", {
                attrs: { disabled: !_vm.toolbarEnabled },
                on: { click: _vm.clearTableRowsSelection }
              }),
              _vm._v(" "),
              _c("div", { staticStyle: { width: "100%" } }),
              _vm._v(" "),
              _c("home-form-table-add-to-other-list-tool", {
                attrs: { disabled: !_vm.toolbarEnabled },
                on: { click: _vm.addAssetsToReservation }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("multiple-object-single-layer-table", {
            ref: "objectDatatable",
            staticStyle: {
              height: "fit-content",
              overflow: "scroll",
              "max-height": "90%"
            },
            attrs: {
              layer: _vm.activeLayer,
              "field-filters": _vm.fieldFilters,
              "can-highlight-objects": true,
              assetReservationTemplate: _vm.template,
              "asset-reservation-objects": _vm.assetReservationObjects,
              "only-used-elements": _vm.onlyUsedElements
            },
            on: {
              "enable-toolbar": function($event) {
                _vm.toolbarEnabled = $event
              }
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28fa9cbe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28fa9cbe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/AssetReservationForm/AssetsTab/AssetSelection.vue
// module id = null
// module chunks = 